import React, { useEffect, useState } from 'react'
import { getallusers } from '../../../service/apiService'
import Deletemodal from '../../common/Modals/Deletemodal'
import Addmodal from '../../common/Modals/Addmodal'

const Users = () => {
    const [datas, setDatas] = useState([])
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [edit, setEdit] = useState(false);
      const [deleteid,setDeleteid] = useState()
        const handleDeleteModal = () => setIsModalOpen(false);
        const handleDeleteModalShow = () => setIsModalOpen(true);
         const [show, setShow] = useState(false);
         const handleClose = () =>  setShow(false)
        const handleShow = () => setShow(true)
    
    const init = async () => {
      let customers =   await getallusers()
      setDatas(customers.data.data)
    }
    
const handleUserDelete = async (id) => {
  setDeleteid(id)
  handleDeleteModalShow()
}
const afterUserDelete = async () => {
  await init()
}

const editUser =  async (id) => {
  setEdit(true)
  setDeleteid(id)
  handleShow()
}
    useEffect(() => {
        (async () => {
         await init()
        })()
    },[])
  return (
    <div>
            <div className="right-content">
                                <div class="page-head d-flex justify-content-between align-items-center flex-wrap">
                                 <h1>MANAGE USERS</h1> 
                                 <div> 
                                  {/* <button className="tb-add-btn" data-bs-toggle="modal" data-bs-target="#add-product" onClick={handleShow}>Add Products+</button> */}
                                 </div>
                               </div>
                               
                               <div class="container-fluid p-0">
                                   <div class="card">
                                     <div class="table-responsive cmn-table dragscroll">
                                    <div className='text-white'>{isModalOpen ? <Deletemodal isModalOpen={isModalOpen} deleteid={deleteid} closeModal={handleDeleteModal} afterUserDelete={afterUserDelete} user={'user'} /> : <></>}</div> 
                                  {show ? <div> <Addmodal show={show} handleClose={handleClose} from={'edituser'} id={deleteid} refresh={afterUserDelete}  /> </div> : <></>}
                                     <table class="w-100">
                                         <thead className='text-white'>
                                          <tr>  
                                          <th>No.</th> 
                                          <th>Full Name</th>   
                                          <th>Firstname</th>   
                                          <th>Lastname</th>  
                                          <th>Email</th>  
                                          <th>Terms And Condition</th>  
                                          <th>Edit</th>
                                          <th>Delete</th>  
                                         </tr>
                                         </thead>
                                         <tbody>
                                         {
                                            datas.map((item,index) => {
                                                return (
                                                    <tr key={index} className='text-white'>
                                                    <td>{index+1}</td>
                                                    <td>{`${item?.firstname} ${item?.lastname}`}</td>
                                                    <td>{item?.firstname}</td>
                                                    <td>{item?.lastname}</td>
                                                    <td>{item?.email}</td>
                                                    <td>{item?.termsandcondition ? "T & C Agreed" : <></> }</td>
                                                    <td class="text-end">
                                                    <button class="act-btns" onClick={() => editUser(item?._id)} ><i class="far fa-edit"></i> Edit</button>  </td>
                                                    <td class="text-end"><button 
                                                      class="act-btns" onClick={() =>handleUserDelete(item?._id)}><i class="far fa-ban"></i> Delete</button> </td>
                                                    </tr>
                                                )
                                            } )
                                         }
                                      
                                             
                                         </tbody>
                                        </table>
    
                                        </div>
                                   </div> 
                               </div>  
                            </div>
    </div>
  )
}

export default Users
